import Projects from "../portfolio/Projects";
import ScrollButton from "../../components/ScrollButton";
import { useEffect } from "react";

const Art = () => {
  useEffect(() => {
    document.title = "Art | Zoe-Alanah Robert";
  });
  return (
    <article className="portfolio-main">
      <section className="portfolio-text">
        <h2 className="title-font pink-text">Art</h2>
      </section>
      <Projects />
      <ScrollButton />
    </article>
  );
};

export default Art;
